export const toLocaleString = (value) => {
  return value ? value.toLocaleString("en-IN") : "";
};

export const formatText = (value) => {
  return value ? value : "--";
};
